import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-poppins\",\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Caveat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-caveat\",\"display\":\"swap\"}],\"variableName\":\"caveat\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConsumerFooter"] */ "/app/src/components/ConsumerFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsumerHeader"] */ "/app/src/components/ConsumerHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfessionalFooter"] */ "/app/src/components/ProfessionalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfessionalHeader"] */ "/app/src/components/ProfessionalHeader.tsx");
